/**
 * Truncates an email address in the center of the local part (e.g. "rishabh...tor@gmail.com")
 * if the local part is longer than maxLocalLength + 3.
 */
export const truncateEmail = (emailStr: string, maxLocalLength = 7): string => {
  if (!emailStr) return "";
  const parts = emailStr.split("@");
  if (parts.length !== 2) return emailStr;
  const localPart = parts[0];
  const domain = parts[1];
  if (!localPart || !domain) return emailStr;
  if (localPart.length <= maxLocalLength + 3) return emailStr;
  return `${localPart.slice(0, maxLocalLength)}...${localPart.slice(-3)}@${domain}`;
};
